import type { FC } from 'react';

import { Box } from '@mui/material';
import { components } from 'react-select';

import { AvatarSizeEnum } from '@shared/enums/avatarSize.enum';
import { isFriend } from '@shared/utils/isFriend';
import { AvatarContainer, UserNameInfoBlock } from 'shared/ui-kit';

import { useSelectContext } from './SelectContext';

import type { OptionType } from './types';
import type { ItemUserModel } from '@shared/models/itemUser.model';
import type { OptionProps } from 'react-select';

export const Option: FC<OptionProps<OptionType>> = (props) => {
  const { data, label } = props;
  const { id, full_name, connection_role, first_name, last_name, avatar, entity_type, is_fake, contacts } =
    data as unknown as ItemUserModel;
  const avatar_icon = avatar?.additional_info?.size_urls?.avatar_icon;
  const avatar_url = avatar?.url;
  const { isShowAvatarInOptions } = useSelectContext();

  return (
    <components.Option {...props}>
      <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'visible' }}>
        {isShowAvatarInOptions ? (
          <>
            <Box sx={{ mr: '10px' }}>
              <AvatarContainer
                id={id}
                firstName={contacts?.is_company ? contacts?.company : first_name}
                lastName={contacts?.is_company ? '' : last_name || ''}
                variant={contacts?.is_company ? 'rounded' : undefined}
                isOwner={false}
                size={AvatarSizeEnum.size28}
                src={avatar_icon || avatar_url || ''}
                isConnected={isFriend(entity_type || '', is_fake)}
                isDistinguish={!!is_fake && !contacts?.is_company}
                isCompany={!!is_fake && contacts?.is_company}
              />
            </Box>
            <UserNameInfoBlock
              firstInfo={full_name?.trim() || contacts?.company}
              secondInfo={connection_role}
            />
          </>
        ) : (
          <>
            {data.icon && (
              <>
                {typeof data.icon === 'function' ? (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mr: '8px',
                      pb: '2px',
                      svg: {
                        width: '16px',
                        height: '16px',
                      },
                    }}
                  >
                    <data.icon />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mr: '8px',
                    }}
                  >
                    {data.icon}
                  </Box>
                )}
              </>
            )}
            {label}
          </>
        )}
      </Box>
    </components.Option>
  );
};
